import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Booth } from './booth.model';
import { BoothPopupService } from './booth-popup.service';
import { BoothService } from './booth.service';

@Component({
    selector: 'jhi-booth-delete-dialog',
    templateUrl: './booth-delete-dialog.component.html'
})
export class BoothDeleteDialogComponent {

    booth: Booth;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private boothService: BoothService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.boothService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'boothListModification',
                content: 'Deleted an booth'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-booth-delete-popup',
    template: ''
})
export class BoothDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private boothPopupService: BoothPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.boothPopupService
                .open(BoothDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth-delete-dialog.component.ts